webpackJsonp([1],{

/***/ "+ZRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__ = __webpack_require__("XYsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df3cfe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__ = __webpack_require__("iPhT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df3cfe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DSyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Home; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home__ = __webpack_require__("zrMz");


var Home = __WEBPACK_IMPORTED_MODULE_0__Home__["a" /* default */];

/***/ }),

/***/ "EWfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("EZYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415d9bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qbHu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415d9bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PageHeader__ = __webpack_require__("+ZRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageFooter__ = __webpack_require__("fyQg");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_0__PageHeader__["a" /* default */],
    PageFooter: __WEBPACK_IMPORTED_MODULE_1__PageFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "Ka/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-footer'
});

/***/ }),

/***/ "MXkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__("EWfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_scss_main__ = __webpack_require__("MXkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_scss_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_scss_main__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App__["a" /* default */] },
  mounted: function mounted() {
    this.loaded();
  },
  methods: {
    loaded: function loaded() {
      var el = document.querySelector(".js-hero-filter");

      setTimeout(function () {
        el.classList.add('hero-filter--opacity');
      }, 500);
    }
  }
});

/***/ }),

/***/ "OPsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_routes__ = __webpack_require__("XoLX");



/* harmony default export */ __webpack_exports__["a"] = ([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__home_routes__["a" /* default */])));

/***/ }),

/***/ "QI0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XYsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-header'
});

/***/ }),

/***/ "XoLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("DSyh");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* Home */],
    name: 'home'
}]);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_index__ = __webpack_require__("evzl");



//import beforeEach from './beforeEach'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__app_index__["a" /* routes */]
});

//router.beforeEach(beforeEach)

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "evzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("OPsd");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "fyQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__ = __webpack_require__("Ka/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4220b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__ = __webpack_require__("tLig");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4220b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iPhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-medium is-bold"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"hero-filter js-hero-filter"}),_vm._v(" "),_c('video',{staticClass:"hero-video",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/video/webm/love-coding.webm","type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":"/static/video/mp4/love-coding.mp4","type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":"/static/video/ogv/love-coding.ogv","type":"video/ogg"}})]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"hero__get-in-touch",attrs:{"href":"https://www.linkedin.com/in/philipsimonelliott/"}},[_vm._v("\n    Get in touch\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-head"},[_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-menu",attrs:{"id":"navbarMenu"}},[_c('div',{staticClass:"navbar-end"},[_c('span',{staticClass:"navbar-item"},[_c('a',{attrs:{"href":"https://www.linkedin.com/in/philipsimonelliott/"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-linkedin"})])])]),_vm._v(" "),_c('span',{staticClass:"navbar-item"},[_c('a',{attrs:{"href":"https://github.com/fyllepo","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-github"})])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-body__content columns is-vcentered"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("\n          Hey I'm Phil, a well-rounded full-stack developer from Leeds.\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_c('strong',[_vm._v("JavaScript?")]),_vm._v(" Check. "),_c('strong',[_vm._v("VueJS?")]),_vm._v(" No problem. "),_c('strong',[_vm._v("PHP?")]),_vm._v(" It's my middle name!\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qbHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-inner"},[_c('page-header'),_vm._v(" "),_c('div',{staticClass:"container has-text-centered"},[_c('router-view')],1),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n        © 2017 - Philip Elliott: PHP/Web Developer from Leeds, UK.\n      ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/philipsimonelliott/"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-linkedin"})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/fyllepo","target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-github"})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"services"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('h2',{staticClass:"title"},[_vm._v("About me")]),_vm._v(" "),_c('p',[_vm._v("I'm a natural problem solver, an idea generator and constant learner.")]),_vm._v(" "),_c('p',[_vm._v("I have worked for both UK and overseas creative agencies on major brands, developed critical in-house platforms for end users, and have spent much of this time honing in on various end to end skills.")]),_vm._v(" "),_c('p',[_vm._v("If you’re in need of a Web Developer with my skillset, why not "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/philipsimonelliott/"}},[_vm._v("get in touch")]),_vm._v(" and maybe we can have a chat. I'm interested in hearing about new projects, or just finding out how I can help with your goals.")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('h2',{staticClass:"title"},[_vm._v("Services")]),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Front-end:")]),_vm._v(" JS, VueJS, AngularJS, jQuery, SASS")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Back-end:")]),_vm._v(" CodeIgniter, Laravel, Lumen, Slim")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Database:")]),_vm._v(" MySQL, SQL, PostgreSQL")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Platforms:")]),_vm._v(" Jekyll, WordPress, Magento, Shopify")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Cloud:")]),_vm._v(" Amazon Web Services, Digital Ocean")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Tools:")]),_vm._v(" Bootstrap, Webpack, NPM, Yarn, Composer")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"fa fa-check"}),_c('strong',[_vm._v("Version Control:")]),_vm._v(" Git, TFS, SVN")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zrMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f68feb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("ziA0");
function injectStyle (ssrContext) {
  __webpack_require__("QI0Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f68feb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f68feb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.38860947aa52214e91fd.js